import { Radio } from '@ksyos/design-system';
import type {
    OsasEvaluationData,
    TreatmentChoice,
} from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import type { OsasFollowUpConsultCustomControlData } from '@common/validation/customControls/osas/osasFollowUpConsultSchema';
import { OsasTrialPeriod } from '@common/enums';
import { useProcessActivityEditContext } from '@frontend/utils';
import { RadioGroupFormGroup } from '../../../processActivityFormGroupFields';

type TrialPeriodFormSectionProps = {
    isRequired?: boolean;
    onChangeTrialPeriod: (reatmentsToChange: TreatmentChoice, trialPeriod: OsasTrialPeriod) => void;
};
export function TrialPeriodFormSection(props: Readonly<TrialPeriodFormSectionProps>) {
    const { isRequired = false, onChangeTrialPeriod } = props;
    const { data, onChange } = useProcessActivityEditContext<
        OsasEvaluationData | OsasFollowUpConsultCustomControlData
    >();

    return (
        <RadioGroupFormGroup
            fieldKey="trialPeriod"
            isRequired={isRequired}
            label="Proefperiode"
            onChange={async (value) => {
                onChange({ trialPeriod: value as OsasTrialPeriod }, 'trialPeriod');
                onChangeTrialPeriod(data.treatmentChoice, value as OsasTrialPeriod);
            }}
            radioGroupLayout="column"
            value={(data.trialPeriod as OsasTrialPeriod) ?? undefined}
        >
            <Radio
                key={OsasTrialPeriod.successful}
                label={OsasTrialPeriod.successful}
                value={OsasTrialPeriod.successful}
            />

            <Radio
                key={OsasTrialPeriod.continue}
                label="Continueren; meer begeleiding nodig"
                value={OsasTrialPeriod.continue}
            />

            <Radio
                key={OsasTrialPeriod.stop}
                label={OsasTrialPeriod.stop}
                value={OsasTrialPeriod.stop}
            />
        </RadioGroupFormGroup>
    );
}
